import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type ParentFormConfigField } from '../model/parent-form-config.type';

export interface updateParentFormConfigAPIResponse {
  studioId: string;
  formFields: Array<ParentFormConfigField>;
  isActive: boolean;
  entity: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface updateParentFormConfigParams {
  formFields: Array<ParentFormConfigField>;
  isActive: boolean;
  entity: 'parent';
}

export const updateParentFormConfigAPI = async (
  params: updateParentFormConfigParams,
) => {
  const response = await baseAPI.post<updateParentFormConfigAPIResponse>(
    `custom-form-config`,
    params,
  );
  return response.data;
};

export const useUpdateParentFormConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: updateParentFormConfigParams) =>
      updateParentFormConfigAPI(params),

    onSuccess: (parentFormConfig) => {
      queryClient.setQueryData([KEYS.PARENT_FORM_CONFIG], parentFormConfig);
      toast.success('Parent form config updated successfully');
    },
    onError: (error) => {
      toast.error('Failed to update parent form config');
      console.error(error);
    },
  });
};
